var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDangerRegular({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 806.284c36.119 0 65.396-29.277 65.396-65.396 0-36.115-29.277-65.396-65.396-65.396s-65.397 29.282-65.397 65.396c0 36.119 29.278 65.396 65.397 65.396z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 196.19c29.947 0 54.221 24.276 54.221 54.222v294.286c0 29.947-24.273 54.221-54.221 54.221s-54.222-24.273-54.222-54.221v-294.286c0-29.945 24.274-54.222 54.222-54.222z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerRegular);
export default __webpack_public_path__ + "static/media/danger-regular.89d3b4f7.svg";
export { ForwardRef as ReactComponent };